import Title from "@components/common/Title";
import React from "react";
import Link from "@components/common/Link";
import HubSpotForm from "@components/common/HubspotForm";
import { HubSpotFormDataModel } from "@models/strapi-components/hubspot";
import { HeroBannerPropsModel } from "@models/hero-banner";

export interface HeroWithFormPropsModel extends HeroBannerPropsModel {
  ctaLink?: string | null;
  hubspotForm?: HubSpotFormDataModel | null;
  pageUrl: string;
}
const FormBanner: React.FunctionComponent<HeroWithFormPropsModel> = ({
  title,
  bigHeader,
  description,
  ctaLink,
  hubspotForm,
  bgColor,
  fontColor,
  pageUrl,
}) => {
  return (
    <div
      className="px-8 py-8 md:px-20 xl:px-[140px] md:py-20 items-center flex flex-col lg:flex-row gap-8"
      style={{ backgroundColor: bgColor ?? "#FFFFFF" }}
    >
      <div className="lg:basis-1/2">
        <Title
          variant="h3"
          titleText={title}
          className="text-primary-orange-50 text-center lg:text-left"
          // style={{ color: fontColor ?? "#000000" }}
        />
        {bigHeader && (
          <Title
            titleText={bigHeader}
            variant="primary"
            className="lg:text-left"
            style={{ color: fontColor ?? "#291E30" }}
          />
        )}
        <Title
          titleText={description}
          variant="paragraph"
          className="text-center lg:text-left mt-[22px]  max-w-[582px] mx-auto lg:ml-0"
          style={{ color: fontColor ?? "#291E30" }}
        />
        {ctaLink && (
          <div>
            <Link href={ctaLink} linkText="LEARN MORE" />
          </div>
        )}
      </div>
      {hubspotForm && (
        <HubSpotForm hubspotForm={hubspotForm} pageUrl={pageUrl} />
      )}
    </div>
  );
};
export default FormBanner;
